//ACTIONS
export const FETCH_ATTRACTIONS_TYPE = "FETCH_ATTRACTIONS_TYPE";
export const FETCH_ATTRACTIONS_RECOMENDATION_TYPE = "FETCH_ATTRACTIONS_RECOMENDATION_TYPE";
export const CREATE_ATTRACTIONS_RECOMENDATION_ACTION = "CREATE_ATTRACTIONS_RECOMENDATION_ACTION";

//SAGA
export const FETCH_ATTRACTIONS_TYPE_DATA = "FETCH_ATTRACTIONS_TYPE_DATA";
export const FETCH_ATTRACTIONS_RECOMENDATION_TYPE_DATA = "FETCH_ATTRACTIONS_RECOMENDATION_TYPE_DATA";
export const CREATE_ATTRACTIONS_RECOMENDATION = "CREATE_ATTRACTIONS_RECOMENDATION";
